import { basicDefaultDisplay } from '@/lib/formatter'
import { User } from '@/redux/user'

export interface BotWorkflowNode {
  id: number
  prompt: string
}

export enum IntervalUnit {
  Second = 'Second',
  Minute = 'Minute',
  Hour = 'Hour',
}

export interface BotWorkflowGroup {
  id: number
  startAt?: number
  startAfterBotActivation: boolean
  interval: number
  intervalUnit?: IntervalUnit
  name: string
  nodes: BotWorkflowNode[]
}

export const getIntervalUnitDisplay = (intervalUnit: IntervalUnit | undefined) => {
  switch (intervalUnit) {
    case IntervalUnit.Second:
      return 'sec'
    case IntervalUnit.Minute:
      return 'min'
    case IntervalUnit.Hour:
      return 'hour'
    default:
      return basicDefaultDisplay
  }
}

export enum BotVersionStatus {
  Published = 'Published',
  Unpublished = 'Unpublished',
}

export interface BotVersion {
  id: number
  botId: number
  createdAt: number
  description?: string
  document?: string
  licenseId: number
  llmId: number
  name: string
  price?: number
  updatedAt: number
  version: string
  status: BotVersionStatus
  workflowGroups: BotWorkflowGroup[]
}

export interface Bot {
  activeVersion?: BotVersion
  hasUnpublishedVersion: boolean
  averageRating: number
  createdBy?: User
  id: number
  soldCount: number
  createdAt: number
}
